export const getOrgRole = (orgRole, orgRoleMap, organizationId) => {
    var _a;
    const fullRole = orgRole.find((role) => role.startsWith(organizationId + '_'));
    if (fullRole) {
        const role = fullRole.split('_')[1];
        return (_a = orgRoleMap[role]) === null || _a === void 0 ? void 0 : _a.label;
    }
    return '';
};
